import { ChevronDown } from 'lucide-react';
import { ReactNode } from 'react';

import { Card } from '@/components/ui/card';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/ui/collapsible';

import { StatValue } from './stat-value';

// The detail expands the tile that summarises it rather than opening a second
// card next to it.
export const CollapsibleStat = ({
  label,
  value,
  caption,
  isAlert = false,
  children,
}: {
  label: string;
  value: string;
  caption?: ReactNode;
  isAlert?: boolean;
  children: ReactNode;
}) => (
  <Collapsible>
    <Card
      className={
        isAlert
          ? 'flex flex-col overflow-hidden border-destructive/30'
          : 'flex flex-col overflow-hidden'
      }
    >
      <CollapsibleTrigger className="group p-4 flex flex-col gap-1.5 text-left hover:bg-muted/40 transition-colors">
        <span className="flex items-center justify-between gap-2">
          <span className="text-[11px] font-medium uppercase tracking-wider text-muted-foreground">
            {label}
          </span>
          <ChevronDown className="size-4 text-muted-foreground group-hover:text-foreground group-data-[state=open]:rotate-180 transition-transform" />
        </span>
        <StatValue value={value} isAlert={isAlert} />
        {caption}
      </CollapsibleTrigger>
      <CollapsibleContent className="overflow-hidden">
        {children}
      </CollapsibleContent>
    </Card>
  </Collapsible>
);
